import { resolveLocale } from '@powerful/config/i18n';

export function formatPrice(cents: number, locale: string): string {
  return new Intl.NumberFormat(resolveLocale(locale), { style: 'currency', currency: 'EUR' }).format(cents / 100);
}

export function formatDuration(minutes: number, locale: string): string {
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  const number = new Intl.NumberFormat(resolveLocale(locale));
  if (hours === 0) return `${number.format(rest)} min`;
  return rest === 0 ? `${number.format(hours)} h` : `${number.format(hours)} h ${number.format(rest)} min`;
}

export function formatDistance(km: number | null, locale: string): string {
  if (km === null || !Number.isFinite(km)) return '—';
  const number = new Intl.NumberFormat(resolveLocale(locale), { maximumFractionDigits: 1 });
  return km < 1 ? `${new Intl.NumberFormat(resolveLocale(locale), { maximumFractionDigits: 0 }).format(km * 1000)} m` : `${number.format(km)} km`;
}

export function formatRating(rating: number, locale: string): string {
  return new Intl.NumberFormat(resolveLocale(locale), { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(rating);
}
